// extracted by mini-css-extract-plugin
export default {"status-box":"VolunteerStatus_status-box__9PXS1","status-box-warning":"VolunteerStatus_status-box-warning__BpGyh","status-box-error":"VolunteerStatus_status-box-error__9l6uP"};